import { Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ROSTER } from './tokens';

export type RosterChipKind = keyof typeof ROSTER.chip;

export function StatusChip({ kind }: { kind: RosterChipKind }) {
  const chip = ROSTER.chip[kind];
  return (
    <Box
      data-testid="status-chip"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        p: '4px 8px 4px 12px',
        borderRadius: '9999px',
        bgcolor: chip.bg,
      }}
    >
      <InfoOutlinedIcon sx={{ width: 16, height: 16, color: chip.fg }} />
      <Box
        component="span"
        sx={{
          fontFamily: ROSTER.font,
          fontSize: 12,
          fontWeight: 700,
          lineHeight: '16px',
          color: chip.fg,
        }}
      >
        {chip.label}
      </Box>
    </Box>
  );
}
